import { useCustomer } from './useCustomer';
import { useIsDev } from './useIsDev';
import { Platform } from 'react-native';
import mixpanel from "mixpanel-browser";
import * as Sentry from '@sentry/react';
import * as braze from "@braze/web-sdk";

export const useAnalytics = () => {
  const { customer } = useCustomer();

  const isDev = useIsDev();

  const identifyUserByEmail = (email: string) => {
    try {
      Sentry.setUser({
        username: email,
      });
    } catch (e) {
      /* empty */
    }

    try {
      if (mixpanel) {
        mixpanel.identify(email);

        mixpanel.people.set({
          $email: email,
        });
      }
    } catch (e) {}
  };

  const trackEvent = (name: string, _variables: Record<string, any> = {}) => {
    const variables = { ..._variables, platform: Platform.OS };

    if (isDev) {
      console.log('📊Tracking event', { name, variables });
    }

    if (Platform.OS === 'web') {
      try {
        mixpanel.track(name, variables);
      } catch (e) {}

      try {
        braze.logCustomEvent(name, _variables);
      } catch (e) {
        console.log(e);
      }

      try {
        // @ts-ignore
        dataLayer.push({ event: name, email: customer?.email, ...variables });
      } catch (err) {}
    }

  };

  return { trackEvent, identifyUserByEmail };
};
